<template>
  <div :class="['userAnswer', classBase + 'comment']">
    <!-- 头像 -->
    <img v-lazy="handleImgSize(item.user.avatar, 'small')" alt="" class="head-img" @click="goUserPage(item.user)" />
    <!-- 用户 -->
    <p :class="['user-name', pUid > 0 ? 'replay-user-name' : '']">
      <span class="user" @click="goUserPage(item.user)">
        {{ item.user.username }}
        <i v-if="isLz">楼主</i>
      </span>
      <template v-if="item[alias]">
        <BlackBoxTag :user="item.user" :blackBox="item[alias]" />
      </template>
      <template v-if="pUid > 0 && pUid != item.to_user.uid">
        <span class="text">回复</span>
        <span class="user" @click="goUserPage(item.to_user)">{{ item.to_user.username }}</span>
      </template>
      <user-tag-group class="mL5" :user="item.user" />
      <!-- <device-source class="mL5" :source="item.source" /> -->
      <!-- 更多 -->
      <el-dropdown class="dorp-down-btn" style="position: absolute;right: 0;top: 0;" placement="bottom">
        <img class="icon" src="@/assets/images/comment-more-icon.svg" alt="" />
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="showTopBtn(item)">
            <span @click="onTopComment(item)">{{ item.is_top == 0 ? "置顶" : "取消置顶" }}</span>
          </el-dropdown-item>
          <el-dropdown-item>
            <span @click.stop="onReportComment(item, 1)">举报</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="showDelBtn(item)">
            <span style="color: orangered" @click.stop="onDelComment(item, 1)">
              删除
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </p>
    <!-- 评论时间 -->
    <p class="time-area">
      <span class="time">{{ item.created_at | dateFormat("YYYY/MM/DD日") }}</span>
      <span class="area" v-if="item.last_ip_area && item.last_ip_area != '未知'">{{ item.last_ip_area }} </span>
    </p>
    <!-- 评论内容 -->
    <div class="content" @click="handleReplay('')">
      <span class="top-tag" v-if="item.is_top == 1">置顶</span>
      <span v-html="replaceEmoji(deleteHtmlStr(item.content))"></span>
    </div>
    <!-- 评论图片 -->
    <div class="comment-img-wrapper" v-if="getContentImgs(item.content) && getContentImgs(item.content).length">
      <template v-for="(img, index) in getContentImgs(item.content)">
        <div v-if="index < 3" :key="index" class="img-item" @click="$imgViewShow(getContentImgs(item.content), index)">
          <img :src="img" alt="" />
          <div v-if="index == 2 && getContentImgs(item.content).length > 3" class="mask">
            +{{ getContentImgs(item.content).length - 3 }}
          </div>
        </div>
      </template>
    </div>
    <!-- 回复框 -->
    <div v-if="showInput" class="input-box">
      <div style="flex-grow: 1;">
        <CommentToComment
          :placeholder="`回复${item.user.username}`"
          @cancel="showInput = false"
          @submit="onCommentToCommentSubmit"
        />
      </div>
    </div>
    <!-- 楼层，评论操作 -->
    <div class="answer-operating">
      <!-- 楼层 -->
      <span class="louNum">
        {{ floor }}
      </span>
      <div class="right">
        <span class="comment-btn" @click="handleReplay('')">
          <img class="icon" src="@/assets/images/comment-comment-icon.svg" style="margin-right: 1px;" alt="" />
          {{ item.child_num > 0 ? item.child_num : 0 }}
        </span>
        <span :class="[item.is_like ? 'active' : '']" @click="onLike(item)">
          <img
            class="icon"
            :src="
              item.is_like
                ? require(`@/assets/images/comment-like-active-icon.svg`)
                : require(`@/assets/images/comment-like-icon.svg`)
            "
            alt=""
          />
          {{ item.like_count > 0 ? item.like_count : 0 }}
        </span>
      </div>
    </div>
    <!-- 子评论 -->
    <div v-if="childList.length" class="user-replay">
      <template>
        <div v-for="child in childList" :key="child.key" class="replay-item">
          <div class="replay-box">
            <span class="user-box">
              <img class="avatar" :src="child.user.avatar" alt="" />
              <a>{{ child.user.username }}</a>
              <template v-if="child.user.uid != child.to_user.uid">
                <span class="answer">回复</span>
                <a>{{ child.to_user.username }}</a>
              </template>
            </span>
            <span>：</span>
            <span
              class="replay-content"
              v-html="replaceEmoji(deleteHtmlStr(xss(child.content)))"
              @click="handleReplay(child)"
            ></span>
          </div>
          <div v-if="child.showInput" class="input-box">
            <div style="flex-grow: 1;">
              <CommentToComment
                :placeholder="`回复${child.user.username}`"
                @cancel="onCommentToCommentChildCancel(child)"
                @submit="onCommentToCommentChildSubmit(child, $event)"
              />
            </div>
          </div>
          <!-- 楼层，评论操作 -->
          <div class="answer-operating">
            <!-- 评论时间 -->
            <p class="left">
              <span class="time">{{ child.created_at | dateFormat("YYYY/MM/DD日") }}</span>
              <span class="area" v-if="child.last_ip_area && child.last_ip_area != '未知'">
                {{ child.last_ip_area }}
              </span>
            </p>
            <div class="right">
              <span class="comment-btn" @click="handleReplay(child)">
                <img class="icon" src="@/assets/images/comment-comment-icon.svg" style="margin-right: 1px;" alt="" />
                {{ child.child_num > 0 ? child.child_num : 0 }}
              </span>
              <span :class="[child.is_like ? 'active' : '']" @click="onLike(child)">
                <img
                  class="icon"
                  :src="
                    child.is_like
                      ? require(`@/assets/images/comment-like-active-icon.svg`)
                      : require(`@/assets/images/comment-like-icon.svg`)
                  "
                  alt=""
                />
                {{ child.like_count > 0 ? child.like_count : 0 }}
              </span>
              <!-- 更多 -->
              <el-dropdown class="dorp-down-btn" placement="bottom">
                <img class="icon" src="@/assets/images/comment-more-icon.svg" alt="" />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="showTopBtn(child)">
                    <span @click="onTopComment(child)">{{ child.is_top == 0 ? "置顶" : "取消置顶" }}</span>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <span @click.stop="onReportComment(child, 1)">举报</span>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="showDelBtn(child)">
                    <span style="color: orangered" @click.stop="onDelComment(child, 2)">
                      删除
                    </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </template>

      <div v-if="item.child_num > 1">
        <span v-if="childList.length == item.child_num" class="close-more" @click="closeChildMore">收起</span>
        <span v-else class="view-more" @click="getCommentChildList(item)">
          {{ childPagination.page_no === 0 ? `共${item.child_num}条回复` : "展开更多回复" }}
        </span>
      </div>
    </div>
    <!-- 举报弹框 -->
    <report-dialog ref="report" />
    <!-- 游客评论提示 -->
    <SightseerCommentTips ref="sightseerCommentTips"></SightseerCommentTips>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Message } from "element-ui";
// plugins
import eventBus from "@/plugins/eventBus";
import { newDebounce, toast } from "@/plugins/util";
// api
import { apiCommentAdd, apiSightseerCommentAdd, apiCommentDel, apiCommentTop, apiCommentList } from "@/api/commentApi";
import { apiContentLike } from "@/api/contentApi";

// components
// import SvgIcon from "@/components/SvgIcon/svgIcon";
import UserTagGroup from "@/components/UserTag/UserTagGroup";
// import DeviceSource from "./deviceSource";
import ReportDialog from "./reportDialog";
import SightseerCommentTips from "./sightseerCommentTips";
import CommentToComment from "./commentToComment";
import { BlackBoxTag } from "@/views/wiki/components/blackBox";

export default {
  name: "commentListItem",
  inject: ["getWxaQrcode", "getServiceQrcodeSrc"],
  mixins: [],
  model: {},
  components: {
    UserTagGroup,
    // DeviceSource,
    // SvgIcon,
    ReportDialog,
    SightseerCommentTips,
    CommentToComment,
    BlackBoxTag
  },
  props: {
    //
    item: {
      type: Object,
      default: () => {}
    },
    // 楼层
    floor: {
      type: String,
      default: ""
    },
    // 是否是楼主
    isLz: {
      type: Boolean,
      default: false
    },
    // 回复的pid
    pid: {
      type: Number,
      default: 0
    },
    // 回复的pid
    pUid: {
      type: Number,
      default: 0
    },
    // 是否显示删除按钮
    showDel: {
      type: Boolean,
      default: true
    },
    // 是否显示置顶按钮
    showTop: {
      type: Boolean,
      default: true
    },
    commentCb: {
      type: Function,
      default: null
    },
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showDialog: false,
      showInput: false,
      inputValue: "",
      childPagination: {
        limit: 5,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      childLoading: false,
      childList: [],
      showChildInput: false,
      childInputValue: ""
    };
  },
  computed: {
    ...mapGetters(["loginUser", "loginUid"])
  },
  watch: {
    item: {
      handler(val) {
        if (this.childList.length === 0) {
          const child = val.child || [];
          this.childPagination.page_no = 0;
          this.childList = child
            .map(item => {
              return {
                ...item,
                showInput: false,
                inputValue: ""
              };
            })
            .slice(0, 1);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 服务端渲染，替代getContentText
    deleteHtmlStr(str = "") {
      return str.replace(/<(?!br\s*\/?)[^>]+>/g, "");
    },
    replaceEmoji(str = "") {
      const emojiMap = this.$store.state.emojiFlatMap;
      let replacedString = str.replace(/_\((.*?)\)/g, (match, p1) => {
        return emojiMap[`_(${p1})`] || "";
      });
      const isAllImages = /^\s*(<img[^>]*>\s*)+$/.test(replacedString);
      if (isAllImages) {
        replacedString = replacedString.replace(/40px;/g, "60px;");
      }
      return replacedString;
    },
    // 服务端渲染，替代getContentImgs
    getContentImgs(str = "") {
      const patten = /<img[^>]+src=['"]([^'"]+)['"]+/g;
      let imgs = [];
      let temp = null;
      while ((temp = patten.exec(str)) != null) {
        imgs.push(temp[1]);
      }
      return imgs && imgs.length ? imgs : null;
    },
    goUserPage(user) {
      window.open(`/user/index/${user.uid}.html`);
    },
    onCommand(command) {
      console.log(command);
    },
    showDelBtn(item) {
      let isShow = false;
      // 是本人
      if (item.user.uid == this.loginUid) {
        isShow = true;
      }
      // 有权限
      if (this.$hasPermission("detail_comment_del")) {
        isShow = true;
      }
      if (!this.showDel) {
        isShow = false;
      }
      return isShow;
    },
    showTopBtn(item) {
      let isShow = false;
      // 是发帖人,楼主
      if (this.isLz) {
        isShow = true;
      }
      // 有权限
      if (this.$hasPermission("detail_comment_top")) {
        isShow = true;
      }
      // 子评论, 不显示
      if (item.pid !== 0 || !this.showTop) {
        isShow = false;
      }
      return isShow;
    },
    onChange() {
      this.$forceUpdate();
    },
    onShowComment() {
      eventBus.$emit("onShowComment", this.item);
    },
    onDelComment(_item, type) {
      apiCommentDel({ id: _item.id }).then(res => {
        if (type == 2) {
          let index = this.childList.indexOf(_item);
          this.item.child_num -= 1;
          this.childList.splice(index, 1);
          if (this.childList.length == 0) {
            this.childList = [this.item.child[1]];
          }
        } else {
          this.$emit("onDel", _item);
        }
      });
    },
    onReportComment(comment) {
      this.$refs.report.id = comment.id;
      // type = 2 评论
      this.$refs.report.type = 2;
      this.$refs.report.isShow = true;
    },
    async onTopComment(comment) {
      try {
        const is_top = comment.is_top == 1;
        const { code } = await apiCommentTop({
          id: comment.id,
          is_top: !is_top
        });
        if (code == 0) {
          this.$message({
            message: `${is_top ? "取消置顶" : "置顶"}成功`,
            type: "success"
          });
          this.$emit("onTop", comment);
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleReplay(child) {
      if (child) {
        child.showInput = !child.showInput;
        return;
      }
      this.showInput = !this.showInput;
    },
    // 游客评论
    sightseerComment: newDebounce(function() {
      // 查询未发出的评论
      const storeComment = localStorage.getItem("__comment_store__") || "";
      const params = JSON.parse(storeComment);
      apiSightseerCommentAdd(params)
        .then(res => {
          if (res && res.code === 0) {
            this.$refs.sightseerCommentTips.open();
            // 10s后自动关闭
            setTimeout(() => {
              this.$refs.sightseerCommentTips.close();
            }, 10000);
          }
        })
        .finally(() => {
          // 删除缓存
          localStorage.removeItem("__comment_store__");
          eventBus.$off("onCommentLoginClose", this.sightseerComment);
        });
    }, 1000),
    onCommentToCommentSubmit(commentContent) {
      this.inputValue = commentContent;
      this.onComment("");
    },
    onCommentToCommentChildCancel(child) {
      child.showInput = false;
    },
    onCommentToCommentChildSubmit(child, commentContent) {
      child.inputValue = commentContent;
      this.onComment(child);
    },
    onComment(child) {
      let params = {
        content: this.inputValue,
        content_id: this.item.content_id,
        pid: this.pid,
        uid: this.item.user.uid,
        type: this.type
      };
      if (child) {
        params.content = child.inputValue;
        params.pid = child.pid > 0 ? child.pid : child.id;
        params.uid = child.user.uid;
      }
      if (!params.content) {
        this.$message({
          type: "info",
          message: "内容为空，请输入！"
        });
        return;
      }
      if (!this.isLoginShow("", "commentLogin")) {
        // 监听是否关闭登录框回调
        eventBus.$on("onCommentLoginClose", this.sightseerComment);
        localStorage.setItem("__comment_store__", JSON.stringify(params));
        return false;
      }
      if (!this.isAuthRealName()) return false;
      // console.log(params);
      apiCommentAdd(params)
        .then(({ code, data }) => {
          if (code === 0) {
            // this.$message.success("回复成功");
            if (this.loginUid && this.loginUser.is_bind_min_app) {
              toast("回复成功");
            } else {
              // 提示可前往小程序
              this.$message({
                title: "",
                customClass: "publish-miniapp-tips",
                duration: 0,
                showClose: true,
                message: (
                  <div class="miniapp-tips-content">
                    <div class="title">
                      <img src={require("@/assets/images/ok-icon.png")} />
                      恭喜您 回复成功
                    </div>
                    <div class="content">
                      <div class="qrcode">
                        <img src={this.getServiceQrcodeSrc()} alt="服务号二维码" />
                      </div>
                      <div class="tips">
                        <div class="title">扫码关注GameKee服务号</div>
                        <div class="desc">随时接收最新消息</div>
                        <div class="tags">
                          <span>评论回复</span>
                          <span>点赞收藏</span>
                          <span>攻略讨论</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              });
              // xxs后关闭
              const duration = this.loginUid && this.loginUser.is_bind_min_app ? 3 * 1000 : 10 * 1000;
              setTimeout(() => {
                Message.closeAll();
              }, duration);
            }

            this.inputValue = "";
            let item = {
              created_at: new Date().getTime() / 1000,
              content: params.content,
              id: data.id,
              like_count: 0,
              user: this.loginUser,
              showInput: false,
              inputValue: "",
              to_user: child ? child.user : this.item.user
            };
            if (child) {
              child.inputValue = "";
            }
            this.showInput = false;
            if (child) {
              child.showInput = false;
              this.$forceUpdate();
            }
            if (this.commentCb) {
              this.commentCb(item);
            } else {
              if (child) {
                // 未展开时
                if (this.childList.length == 1) {
                  this.childList = [item];
                } else {
                  this.childList.unshift(item);
                }
              } else {
                this.item.child = this.item.child || [];
                this.item.child.unshift(item);
              }
              this.item.child_num += 1;
            }
          }
        })
        .finally(() => {
          // 删除缓存
          localStorage.removeItem("__comment_store__");
          eventBus.$off("onCommentLoginClose", this.sightseerComment);
        });
    },
    onLike: newDebounce(
      function(commentItem) {
        // if (!this.isLogin()) {
        //   return false;
        // }
        let params = {
          is_like: commentItem.is_like ? 0 : 1,
          origin_id: commentItem.id,
          type: 2
        };
        apiContentLike(params).then(res => {
          commentItem.is_like = params.is_like;
          if (params.is_like) {
            commentItem.like_count++;
          } else {
            commentItem.like_count--;
          }
        });
      },
      500,
      true
    ),
    // 获取子评论
    getCommentChildList(item) {
      let { childPagination } = this;
      if (this.childLoading) return;
      ++childPagination.page_no;
      if (childPagination.page_no > childPagination.page_total) return;

      let params = {
        ...this.childPagination,
        content_id: item.content_id,
        pid: item.id,
        type: this.type,
        order: 1
      };
      this.type === 5 && (params.type = 5);
      apiCommentList(params)
        .then(res => {
          // 需要刷新的数量
          const needRefeshNum = this.childList.length - (childPagination.page_no - 1) * childPagination.limit;

          const data =
            childPagination.page_no == 1
              ? res.data.slice(1)
              : needRefeshNum > 0
              ? res.data.slice(needRefeshNum)
              : res.data;
          const child = this.childList.concat(data);
          this.childList = child.map(item => {
            return {
              ...item,
              showInput: false,
              inputValue: ""
            };
          });
          this.childPagination = res.meta.pagination;
        })
        .finally(_ => {
          this.childLoading = false;
        });
    },
    // 收起子评论
    closeChildMore() {
      this.childPagination.page_no = 0;
      this.childList = this.childList.slice(0, 1);
    }
  }
};
</script>

<style lang="less" scoped>
.userAnswer {
  padding-left: 49px;
  position: relative;
  margin-bottom: 12px;

  .head-img {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer;
  }

  .user-name {
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
    font-weight: 400;
    font-size: 13px;
    color: #999999;
    line-height: 18px;
    cursor: pointer;
    padding-right: 50px;

    i {
      font-style: normal;
      color: #dcba77;
      border-radius: 2px;
      border: 1px solid #dcba77;
      font-size: 10px;
      padding: 0 2px;
      margin-left: 5px;
    }

    &.replay-user-name {
      color: @text-gray;

      .user {
        color: #0063ce;
      }

      .text {
        color: @text-gray;
        padding: 0 4px;
      }
    }

    .louNum {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .time-area {
    color: #999;
    font-size: 12px;
    margin-bottom: 9px;
    .area {
      margin-left: 2px;
    }
  }

  .content {
    font-size: 14px;
    color: #333;
    line-height: 20px;
    margin-bottom: 10px;
    white-space: pre-wrap;
    .top-tag {
      border-radius: 2px;
      border: 1px solid #00afe8;
      font-size: 10px;
      font-weight: 400;
      color: #00afe8;
      line-height: 15px;
      padding: 0 4px;
      margin-right: 2px;
    }
  }

  .comment-img-wrapper {
    display: flex;
    margin-bottom: 20px;

    .img-item {
      width: 110px;
      height: 100px;
      cursor: pointer;
      position: relative;
      border-radius: 6px;
      overflow: hidden;

      & + .img-item {
        margin-left: 12px;
      }

      .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: fade(#000, 70%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 16px;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .answer-operating {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #868686;
    user-select: none;
    margin-bottom: 16px;
    .louNum {
      font-size: 12px;
      color: #999;
      display: flex;
      align-items: center;
    }

    .right {
      display: flex;
      align-items: center;
      height: 20px;
      gap: 15px;
      .icon {
        width: 20px;
        height: 20px;
      }
      > span {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 20px;
        font-weight: 400;
        font-size: 10px;
        color: #999999;
      }
    }
  }

  .input-box {
    display: flex;
    align-items: stretch;
    margin-bottom: 10px;

    /deep/ .el-input-group__append {
      background: @text-basic;
      color: @text-primary;
      border: none;
    }
  }

  .userAnswer {
    padding-left: 46px;
    padding-top: 10px;
    border: none;

    .head-img {
      top: 10px;
      left: 10px;
      width: 28px;
      height: 28px;
    }

    .user-name {
      color: #00afe8;
      font-size: 12px;

      em {
        font-style: normal;
        color: #787878;
        margin: 0 5px;
      }
    }

    .answer-operating {
      margin-top: 5px;
      justify-content: flex-end;
    }
  }
}

.view-more {
  color: #00afe8;
  cursor: pointer;
  margin-right: 10px;
}

.close-more {
  color: #00afe8;
  cursor: pointer;
}

.dorp-down-btn {
  height: 20px;
  line-height: 20px;
  cursor: pointer;
  font-size: 18px;
}

.user-replay {
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 12px;

  .replay-item {
    font-size: 13px;
    margin-bottom: 8px;
    .replay-box {
      margin-bottom: 10px;
      line-height: 16px;
    }

    .user-box {
      color: @text-gray;
      display: inline-block;

      .avatar {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #e3e3e3;
        margin-right: 4px;
        vertical-align: top;
      }
      .answer {
        color: #152c66;
      }
      span {
        padding: 0 4px;
      }

      a {
        color: #868686;
      }
    }

    .replay-content {
      color: #333;
      /deep/ img {
        margin-top: 16px;
        border-radius: 6px;
        width: 110px;
        height: 100px;
        object-fit: cover;
      }
    }
  }
}
</style>
